import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useDialogToggleWithData } from '../../hooks/useDialogToggleWithData';

import CardWithProgressLoading from '../CardWithLoadingProgress';
import DialogClosedShiftDetails from '../DialogClosedShiftDetails';

import CloseSection from './CloseSection';
import OpenSection from './OpenSection';

import styles from './styles';

const useStyles = makeStyles(styles);

const ShiftWidget = ({
  isOpen = false,
  currencies = [],
  onOpenCash,
  onCloseCash,
}) => {
  const { t } = useTranslation('common');
  const classes = useStyles();

  const [
    openDialogClosedShiftDetails,
    closedShiftDetailsData,
    handleOpenDialogClosedShiftDetails,
    handleCloseDialogClosedShiftDetails,
  ] = useDialogToggleWithData(false, null);

  const onCompletedClosedCash = useCallback(
    (data) => {
      setTimeout(() => {
        handleOpenDialogClosedShiftDetails({
          started_at: data.started_at,
          ended_at: data.ended_at,
          currencies: data.currencies,
        });
      }, 500);

      onCloseCash();
    },
    [handleOpenDialogClosedShiftDetails, onCloseCash],
  );

  return (
    <CardWithProgressLoading
      loading={false}
      progressSize={65}
      fullHeight={false}
      className={classes.card}
    >
      <Typography variant="h6" className={classes.title}>
        {t('payments.shift.currentCash')}
      </Typography>

      <Box className={classes.content}>
        {!isOpen && <OpenSection onCompleted={onOpenCash} />}

        {isOpen && (
          <CloseSection
            currencies={currencies}
            onCompleted={onCompletedClosedCash}
          />
        )}
      </Box>

      {openDialogClosedShiftDetails && closedShiftDetailsData && (
        <DialogClosedShiftDetails
          open={openDialogClosedShiftDetails}
          onClose={handleCloseDialogClosedShiftDetails}
          data={closedShiftDetailsData}
        />
      )}
    </CardWithProgressLoading>
  );
};

ShiftWidget.propTypes = {
  isOpen: PropTypes.bool,
  currencies: PropTypes.arrayOf(
    PropTypes.shape({
      currency_id: PropTypes.string,
      amount: PropTypes.string,
    }),
  ),
  onOpenCash: PropTypes.func.isRequired,
  onCloseCash: PropTypes.func.isRequired,
};

ShiftWidget.defaultProps = {
  isOpen: false,
  currencies: [],
};

export default ShiftWidget;
